import InspectionList from './InspectionList';
import InspectionShow from './InspectionShow';
import Icon from '@material-ui/icons/FindReplace';

const ops = {
    list: InspectionList,
    show: InspectionShow,
    icon: Icon
};

export default ops;